import { useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../../reducers';
import { doubleArrowIcon } from '../../../assets/images';
import SidebarList from '../SideBars/SideBarList';
import { PageNavOption, pageNavOptions } from './NavOptions';

interface MainLeftSideBarProps {
    seletedPageOption: PageNavOption;
    onClickPageOption: (opt: PageNavOption) => void;
    isSecondSidebarClosed: boolean;
    setIsSecondSidebarClosed: (isClosed: boolean) => void;
}

const MainLeftSideBar = (props: MainLeftSideBarProps) => {
    const {
        seletedPageOption,
        onClickPageOption,
        isSecondSidebarClosed,
        setIsSecondSidebarClosed,
    } = props;

    const { editor } = useSelector((state: ReduxStateShape) => ({
        ...state.templateEditor,
    }));

    return (
        <div className={'main-left-side-bar'}>
            {editor && ['pageEditor', 'componentEditor'].includes(editor) && (
                <>
                    <hr />
                    <SidebarList
                        options={pageNavOptions}
                        selectedOption={seletedPageOption}
                        onClick={onClickPageOption}
                    />

                    {isSecondSidebarClosed && (
                        <img
                            className="toggle-left-side-bar-icon"
                            src={doubleArrowIcon}
                            alt="open-left-side-bar-icon"
                            onClick={(e: React.MouseEvent<HTMLElement>) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsSecondSidebarClosed(false);
                            }}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default MainLeftSideBar;
